import { h } from 'preact';
import cx from 'classnames';
import intl from 'react-intl-universal';
import _ from 'lodash';
import SignInStore from '@src/business-components/sign-in/store';
import wrapStore from '@src/utils/wrap-store';
import Button from '@src/components/button';
import LoadingDiv from '@src/components/loading-div';
import Form from "@src/components/form";
import FormItem from "@src/components/form-item";
import Input from "@src/components/input";
import Checkbox from "@src/components/checkbox";
import "./index.less";
import {createRef, forwardRef} from "preact/compat";
import {useEffect} from "preact/hooks";

const CreateForm = Form;

/**
 * 用户登录
 * @param className {string}
 * @param store {SignInStore}
 * @param bottom {ComponentChildren}
 * @param needThirdLogin {boolean}
 **/
const SignIn = forwardRef(({ className, store, bottom, needThirdLogin = true }, ref = createRef()) => {
  store.use();
  if (store.loadingStatus) {
    return (
      <div className={cx('xfe_common_root', className)} style={{ height: '300px' }}>
        <LoadingDiv />
      </div>
    );
  }
  if (store.needActiveStatus) {
    return (
      <div className={cx('xfe_common_login_root', className)} ref={ref}>
        <div className={'xfe_common_login_content'}>
          <div className={'xfe_common_login_description'}>{intl.get('PAGE.SIGN_IN.ACTIVE.CONTENT1')}</div>
          <div className={'xfe_common_login_description'}>{intl.get('PAGE.SIGN_IN.ACTIVE.CONTENT2')}</div>
        </div>
        <div className={'xfe_common_login_activeTip'}>
          <img src={"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAARCAYAAAA7bUf6AAAAAXNSR0IArs4c6QAAAqRJREFUOE+Vk01IVFEUx//nPkczkhmooNy0iOhj5s3MeyNpAxEkgRtLbKgIglq0zyIIEXSRmxK1TRARhWJB0Bdh0GoqUMPevDszzw9cmIFahNkEmt/zTryBsZkRoS7cxT33f37nnHvPIRQswzBcilJcx0TnmOElYCeABQZPE4m3xMpDTTv4JdeNcg/x+PBhht3FjP0AfhKQtMFTAG0j0D6AvQBWCdSRTi81VVRUrDr+65BYzDpLAt0ApwQpN4jWngYCgd+5QRKJEV/atm8CfArAh6XFuZpwOLyYgRhGopIE9YEwukx2TTgYnHbs0Wi0yO3Z/optehAKqc+zwFgs2UCC2kF4pgfVCDGzkPGhMYDd4LWgrutfs2IpJzyM+RQDd0KaeiU3KzNutYFxjcBnSMrkeQb1MPhSSPM/yhUaxrhbKAu/GNwZ0vwN+XeGS4iScRBmSUrrBQPHSorFLq/Xu/KvEEcnpdXMQBOZcmgMZE/pQX/1xu/ePBNHa5qJapDoJVNaswy8CWnqhf+FGIa1VygYdSBTBAxqmlpfCJFSehhFKQJ1apov700cbSxm+UngkwMZBHirrvl9hZBoNLrF7dnxjYBWTVPbNgYZvsiw71FMWq0ENLKNQ6GQOloo7O/vL3UaqtCeeRM59JLBx8k0zT0g12eAXuuary6vF8yhAMgeAFOPrquX87t3uDJt2x8ZuJvp2Ji0bhFwXRBdDQZ9HVmxaZrlIFcviLr1oK89azeMkd1CsQcALgOvHshAWlpaRO3J+ndEdJSB28uLc82blmAmj4DoCcDlYJzQdf/79QGcnJwsnZlJdYEoAmfsQfeZuc+2aUJRRBkz+yE4AkYtgB9gjjiAvCn+W0LiNCAaQXDG3lkCADubGfMMPF5bQWtVlfo96/MHu047GCoGX4QAAAAASUVORK5CYII="} alt={'tip'} />
          {intl.get('PAGE.SIGN_IN.ACTIVE.TIP')}
        </div>
        <div className={'xfe_common_login_activeBtnBox'}>
          <Button onClick={store.activeHandle} className={'xfe_common_login_btn'}>
            {intl.get('PAGE.SIGN_IN.ACTIVE.REACTIVATE_ACCOUNT.TEXT')}
          </Button>
          <Button onClick={store.backToSignIn} type={'primary'} className={'xfe_common_login_btn'}>
            {intl.get('PAGE.SIGN_IN.ACTIVE.CANCEL.TEXT')}
          </Button>
        </div>
      </div>
    );
  }
  return (
    <div className={cx('xfe_common_login_root', className)} ref={ref}>
      <CreateForm
        formRef={store.formRef}
        initialValue={store.formValue}
        onValuesChange={(props, changedValues, allValues) => {
          // console.log(props, changedValues, allValues);
          store.checkCodeValue(allValues);
        }}
      >
        <FormItem
          name="email"
          validateFirst={true}
          validateTrigger={'onBlur'}
          rules={[
            {
              required: true,
              message: intl.get('PAGE.SIGN_IN.EMAIL.INPUT.ERROR.EMPTY')
            },
            {
              validator: (rule, value, callback) => {
                if (/\s/.test(value)) {
                  callback(new Error(intl.get('PAGE.SIGN_IN.EMAIL.INPUT.ERROR.FORMAT')));
                }
                if (!/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(_.trim(value))) {
                  callback(new Error(intl.get('PAGE.SIGN_IN.EMAIL.INPUT.ERROR.FORMAT')));
                } else {
                  callback();
                }
              }
            }
          ]}
        >
          <Input className={'xfe_common_login_input'} disabled={store.formLock} maxLength={50} placeholder={intl.get('PAGE.SIGN_IN.EMAIL.INPUT.PLACEHOLDER')} />
        </FormItem>
        <FormItem
          name="password"
          validateTrigger={'onBlur'}
          rules={[
            {
              required: true,
              whitespace: true,
              message: intl.get('PAGE.SIGN_IN.PASSWORD.INPUT.ERROR.EMPTY')
            },
            {
              validator: (rule, value, callback) => {
                if (/\s/.test(value)) {
                  callback(new Error(intl.get('PASSWORD.INPUT.ERROR.BLANK')));
                }
                if (!/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z][\s\S]{7,30}$/.test(_.trim(value))) {
                  callback(new Error(intl.get('PAGE.SIGN_IN.PASSWORD.INPUT.ERROR.FORMAT')));
                }
                callback();
              }
            }
          ]}
        >
          <Input
            className={'xfe_common_login_input'}
            disabled={store.formLock}
            type={'password'}
            maxLength={30}
            placeholder={intl.get('PAGE.SIGN_IN.PASSWORD.INPUT.PLACEHOLDER')}
          />
        </FormItem>
      </CreateForm>
      <Checkbox className={'xfe_common_login_protocol'} onChange={e => store.changeProtocolStatus(e.target.checked)}>
        {intl.getHTML('PAGE.SIGN_IN.PROTOCOL', {
          privacyLink: store.link.privacyAgreement,
          privacyName: intl.get('PAGE.SIGN_IN.PROTOCOL.PRIVACY_NAME'),
          userAgreementLink: store.link.userAgreement,
          userAgreementName: intl.get('PAGE.SIGN_IN.PROTOCOL.USER_AGREEMENT_NAME')
        })}
      </Checkbox>
      <div className={'xfe_common_login_btnBox'}>
        <Button onClick={store.loginHandle} type={store.submitBtnDisable ? 'disable' : ''} className={'xfe_common_login_btn'}>
          {intl.get('PAGE.SIGN_IN.SUBMIT.TEXT')}
        </Button>
      </div>
      {bottom}
      {needThirdLogin && (
        <div className={'xfe_common_login_thirdPartyLogin'}>
          <div className={'xfe_common_login_thirdPartyLoginTitle'}>
            <div className={'xfe_common_login_thirdPartyLoginLine'} />
            <div className={'xfe_common_login_thirdPartyLoginText'}>{intl.get('PAGE.SIGN_IN.THIRD_LOGIN.TITLE')}</div>
            <div className={'xfe_common_login_thirdPartyLoginLine'} />
          </div>
          <div className={'xfe_common_login_thirdPartyLoginLogo'}>
            {store.loginType.map(thirdStore => (
              <span
                onClick={async () => {
                  const result = await thirdStore.login();
                  if (result) {
                    store.loadingStatus = true;
                  }
                }}
              >
                <img src={thirdStore.logo} alt={thirdStore.name} />
              </span>
            ))}
          </div>
        </div>
      )}
    </div>
  );
});

export default wrapStore(SignIn, SignInStore);
